/**
 * The three /how-it-works steps — single source for the visible page, the HowTo
 * JSON-LD (`plugins/seoJsonLdBuilders.ts`) and the /how-it-works crawl snippet
 * (`plugins/publicCrawlSnippets.ts`). PBI #1293.
 *
 * Build plugins import this module under Node, so it must stay free of theme,
 * Mantine, or browser imports. That is why it lives outside `landingContent.ts`.
 */

/** One numbered step rendered on /how-it-works. */
export interface HowItWorksStep {
  title: string;
  description: string;
  detail: string;
}

export const HOW_IT_WORKS_STEPS = [
  {
    title: 'Tell us who matters',
    description:
      'Add the people you care about \u2014 family, friends, colleagues. Enter their birthday, anniversary, or any custom date. You can start with just one person; it takes less than 2 minutes.',
    detail:
      'Supports birthdays, wedding anniversaries, work milestones, and custom occasion types. On Personal, you can also import a contact file instead of typing each person.',
  },
  {
    title: 'Choose your gift and make it personal',
    description:
      'Browse free e-cards, physical mailed cards, or flower arrangements for every occasion. Personalize an e-card with your own photo or video, write a message on a mailed card, or pick a bouquet \u2014 then choose exactly when it should arrive.',
    detail:
      'E-cards support image or video uploads up to 50 MB. Mailed cards let you personalize each writable panel. For flowers, choose an arrangement and a delivery date.',
  },
  {
    title: 'Auto Send delivers on time',
    description:
      'On the scheduled date, Auto Send delivers your e-card by email, posts your mailed card, or sends flowers from a local florist. A few days before delivery, you\u2019ll get a reminder so you can review, tweak, or just let it go.',
    detail: 'E-cards support 4 daily delivery windows: early morning, morning, afternoon, or evening.',
  },
] as const satisfies readonly HowItWorksStep[];
